export const SESSION_KEYS = {
	ACCESS_TOKEN: 'cinny_access_token',
	DEVICE_ID: 'cinny_device_id',
	USER_ID: 'cinny_user_id',
	BASE_URL: 'cinny_hs_base_url'
} as const;

export const AFTER_LOGIN_REDIRECT_KEY = 'after_login_redirect_url';
export const SETTINGS_STORAGE_KEY = 'settings';
export const SPACE_ROOMS_KEY = 'spaceRooms';
export const NAV_TO_ACTIVE_PATH_KEY = 'navToActivePath';
export const CLOSED_NAV_CATEGORIES_KEY = 'closedNavCategories';
export const CLOSED_LOBBY_CATEGORIES_KEY = 'closedLobbyCategories';
export const OPENED_SIDEBAR_FOLDER_KEY = 'openedSidebarFolder';
export const CALL_PREFERENCES_KEY = 'callPreferences';
